import { runEvalScript } from "..";

export async function runBeforeRender(compId: number) {
  const beforeRenderState = await runEvalScript(
    `$._blingsio.dataManager.runBeforeRender(${compId})`
  );
  return beforeRenderState;
}
